<template>
  <div class="model-content">
    <div
      class="model_64"
      :class="
        posterList.lang == 'ug' || !posterList.lang ? 'model_ug' : 'model_zh'
      "
    >
      <img class="img-box" :src="url" />

      <div class="merchant-name">
        <div class="merchant-name-title">{{ posterList.merchant_name }}</div>
      </div>

      <div class="date">
        <div class="date_text">{{ posterList.date }}</div>
      </div>

      <div class="food_name">
        <div class="food_name_text">{{ posterList.food_name }}</div>
      </div>

      <div class="food_img">
        <img :src="posterList.food_img" alt="" />
      </div>

      <div class="food_price" :style="{ fontSize: posterList.fontSize + 'px' }">
        {{ posterList.food_price }}
      </div>

      <div class="old_price">
        <div class="old_price_text" v-if="posterList.lang == 'ug'">
          ئەسلى باھاسى :
        </div>
        <div class="old_price_text" v-if="posterList.lang == 'zh'">原价 :</div>
        <div class="line">
          <span class="number"> {{ posterList.old_price }} </span>
          <span v-if="posterList.lang == 'ug'"> يۈەن </span>
          <span v-if="posterList.lang == 'zh'"> 元 </span>
        </div>
      </div>

      <div class="merchant_qrcode">
        <img :src="posterList.merchant_qrcode" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "model_64",
  data() {
    return {
      posterList: {},
      url: require("../../img/poster/model_64.jpg"),
    };
  },
  created() {
    this.canvasfortitle(
      this.$route.query.merchant_name,
      this.$route.query.food_name,
      this.$route.query
    );
  },
  methods: {
    canvasfortitle(merchant_name, food_names, query) {
      // 替换商家名称和食物名称中的特定字符
      const replaceChars = (str) => {
        return str
          .replaceAll("(", "-")
          .replaceAll("（", "-")
          .replaceAll(")", " ")
          .replaceAll("）", " ");
      };

      // 处理商家名称和食物名称
      const res_name = replaceChars(merchant_name);
      const food_name = replaceChars(food_names);

      // 更新 posterList
      this.posterList = query;
      this.posterList.merchant_name = res_name;
      this.posterList.food_name = food_name;
      this.posterList.food_price = parseFloat(query.food_price);

      // 确定字体大小
      const priceLength = query.food_price.toString().length;
      let fontSize = 55;
      if (priceLength <= 2) {
        fontSize = 55;
      } else if (priceLength === 3) {
        fontSize = 50;
      } else if (priceLength === 4) {
        fontSize = 48;
      } else if (priceLength === 5) {
        fontSize = 44;
      }

      this.posterList.fontSize = fontSize;
    },
  },
};
</script>

<style scoped>
@import url("../../css/model_64/title.css");
.model-content {
  width: 388px;
  height: 737px;
  position: relative;
  margin: auto;
  display: flex;
  justify-content: center;
}

.model_64 {
  width: 388px;
  height: 737px;
  position: relative;
}

.model_ug {
  direction: rtl;
}

.model_zh {
  direction: ltr;
}

.img-box {
  width: 100%;
  height: 100%;
}

.merchant-name {
  position: absolute;
  top: 88px;
  right: 50%;
  transform: translateX(49%);
  color: #d8ff00;
  width: 282px;
  height: 56px;
  padding: 10px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.merchant-name-title {

  display: -webkit-box;
  -webkit-box-orient: vertical;
  /*垂直排列*/
  line-clamp: 2;
  -webkit-line-clamp: 2;
  /*只显示6行*/
  overflow: hidden;
  /*溢出隐藏*/
  text-overflow: ellipsis;
  /*省略号代替*/
}

.model_ug .merchant-name-title {
  font-family: "NurjanbayBuyluq-" !important;
  font-size: 48px;
}
.model_zh .merchant-name-title {
  font-family: "FZCQK--GBK1-0" !important;
  line-height: 30px;
  font-size: 26px;
}

.date {
  position: absolute;
  top: 174px;
  right: 50%;
  transform: translateX(50%);
  color: #403c3c;
  background-color: #fff;
  border-radius: 30px;
  width: max-content;
  padding: 0px 15px;
  direction: ltr;
  height: 30px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
}
.date_text {
  font-family: "UzluqEgme" !important;
  margin-top: 5px;
}

.food_name {
  position: absolute;
  width: 190px;
  height: 56px;
  top: 288px;
  right: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  transform: rotate(20deg);
}

.food_name_text {
  color: #fffc00;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  /*垂直排列*/
  line-clamp: 2;
  -webkit-line-clamp: 2;
  /*只显示6行*/
  overflow: hidden;
  /*溢出隐藏*/
  text-overflow: ellipsis;
  /*省略号代替*/
}
.model_ug .food_name_text {
  font-family: "NurjanbayBuyluq-" !important;
  font-size: 45px;
}
.model_zh .food_name_text {
  font-family: "FZCQK--GBK1-0" !important;
  line-height: 30px;
  font-size: 25px;
}
.food_img {
  position: absolute;
  top: 340px;
  left: 31px;
  width: 326px;
  height: 205px;
  border-radius: 50%;
  overflow: hidden;
}

.food_img img {
  width: 100%;
  height: 100%;
  clip-path: ellipse(50% 50% at 50% 50%);
  object-fit: cover;
}

.food_price {
  position: absolute;
  top: 265px;
  left: 42px;
  width: 114px;
  color: #8f00a5;
  text-align: center;
  font-weight: bold;
  transform: rotate(-24deg);
  font-family: "UzluqEgme" !important;
}
.old_price {
  position: absolute;
  bottom: 160px;
  font-size: 15px;
  color: #fff;
  display: flex;
  align-items: center;
}
.old_price .line {
  text-decoration: line-through;
  padding-inline: 4px;
}
.number {
  font-family: "UzluqEgme" !important;
}

.model_ug .old_price {
  right: 130px;
}

.model_zh .old_price {
  left: 145px;
}

.merchant_qrcode {
  position: absolute;
  bottom: 29.5px;
  left: 45px;
  width: 93px;
  height: 93px;
  box-sizing: border-box;
}

.merchant_qrcode img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
</style>
